import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { adhikariInterface } from "../../adhikari.interface";
import { ADHIKARI_CONSTANT } from "../constant/adhikari.constant";
import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";

@Injectable({
  providedIn: "root",
})
export class adhikariService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  //soft delete
  public updateData(adhikariData: adhikariInterface) {
    let adhikariId = adhikariData.id;
    return this.httpClient.put(
      `${ADHIKARI_CONSTANT.ADHIKARI_DATA}/${adhikariId}`,
      adhikariData
    );
  }

  public createAdhikariData(adhikariData: adhikariInterface) {
    return this.httpClient.post(ADHIKARI_CONSTANT.ADHIKARI_DATA, adhikariData);
  }

  public getAdhikariData(adhikariData: adhikariInterface) {
    return this.httpClient.post(
      `${ADHIKARI_CONSTANT.ADHIKARI_LIST}`,
      adhikariData
    );
  }

  public getAdhikariEdit(adhikariId: any) {
    return this.httpClient.get(
      `${ADHIKARI_CONSTANT.ADHIKARI_DATA}/${adhikariId}`
    );
  }

  public updateAdhikariData(adhikariData: adhikariInterface) {
    let adhikariId = adhikariData.id;
    return this.httpClient.put(
      `${ADHIKARI_CONSTANT.ADHIKARI_DATA}/${adhikariId}${ADHIKARI_CONSTANT.ADHIKARI_ASSEMBLY}`,
      adhikariData
    );
  }

  //other Api

  public getDepartment() {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.DEPARTMENT}`);
  }

  public getAssemblyData() {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.ASSEMBLIES_LIST}`);
  }

  public getGaonData(assemblyId: any) {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.GAON_LIST}/${assemblyId}`);
  }

  public getGatNumberData(gatId: any) {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.GATNO_LIST}/${gatId}`);
  }

  public getGanNumberData(ganId: any) {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.GAN_NUMBER_LIST}/${ganId}`);
  }

  public getCast() {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.CAST}`);
  }
  public getSubCast(id: any) {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.SUBCAST}/${id}`);
  }

  public getTotalCount() {
    return this.httpClient.get(`${ADHIKARI_CONSTANT.TOTAL_COUNT}`);
  }

  public getPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Adhikari_Page);
  }
  public restoreRecord(rowData: any) {
    return this.httpClient.patch(`/adhikari/restore/${rowData.id}`, {});
  }

}
